const PMT = (ir, np, pv, fv, type) => {
    /*
     * ir   - interest rate per month
     * np   - number of periods (months)
     * pv   - present value
     * fv   - future value
     * type - when the payments are due:
     *        0: end of the period, e.g. end of month (default)
     *        1: beginning of period
     */
    var pmt, pvif;

    fv || (fv = 0);
    type || (type = 0);

    if (ir === 0)
        return -(pv + fv) / np;

    pvif = Math.pow(1 + ir, np);

    pmt = -ir * pv * (pvif + fv) / (pvif - 1);

    if (type === 1)
        pmt /= (1 + ir);

    return pmt;
}

const calculateLoan = (amount, term, repayments, rate) => {
    repayments = parseInt(repayments);
    const interest = rate;
    let repayment = 0;
    switch (repayments) {
        case 3: {
            repayment = 52;

            break;
        }

        case 2: {
            repayment = 26;

            break;
        }

        case 1: {
            repayment = 12;

            break;
        }
    }

    const result = parseFloat(PMT((interest / 100) / repayment, term * repayment, amount) * -1);
    const mrepay = result.toFixed(2);
    const total = result * (term * repayment);
    const loanTotal = total;
    repayment = (total - amount);
    const repaymentTotal = repayment;

    return  {
        mrepay: mrepay,
        tcredit: loanTotal,
        trepay: repaymentTotal
    }
}


export default calculateLoan;